
function Snspace(props) {

    return (
        <div className="Snspace">        
            <a href={props.href} target="_blank">
                <img src={props.src} alt={props.alt}/>
            </a>
            <div className="discribe-space">
                <h2>{props.title}</h2>
                <p className="p-caption">{props.caption}</p>
                <p className="p-discribe">{props.discribe1}</p>
                <p className="p-discribe">{props.discribe2}</p>
                <a href={props.href} target="_blank">
                    {props.text}
                </a>
           </div>
        </div>
    );
}

export default Snspace;